export default "__VITE_ASSET__DA$ti$el__"